import React, { useEffect } from 'react';
import { getProductEntityName } from '../Product.config';

import { useAssignDesignOutputVerification } from '../Product.hooks';
import {
  ProductVerification,
  BaseProductAssignDialogProps
} from '../Product.interface';
import AssignVerificationDialog from './AssignVerificationDialog';

export type DesignOutputAssignVerificationDialogProps = BaseProductAssignDialogProps<'designOutputId'>;

const DesignOutputAssignVerificationDialog: React.FC<DesignOutputAssignVerificationDialogProps> = (
  props: DesignOutputAssignVerificationDialogProps
) => {
  const {
    open,
    productId,
    designOutputId,
    selectedItems,
    onCancel,
    onError,
    onAssigned
  } = props;
  const {
    updatedProductDesignOutput,
    isAssigning,
    error: assignError,
    assignVerifications
  } = useAssignDesignOutputVerification(productId, designOutputId);

  // handle notification to parent after assigning
  useEffect(() => {
    if (updatedProductDesignOutput) {
      onAssigned?.(updatedProductDesignOutput);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedProductDesignOutput]);

  useEffect(() => {
    if (assignError) {
      onError?.(assignError);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assignError]);

  return (
    <AssignVerificationDialog
      {...{ open, productId, selectedItems, onCancel, onError }}
      isLoading={isAssigning}
      contentText={`Search for Verifications to assign to the ${getProductEntityName(
        'designOutput'
      )}.`}
      onSubmit={(verifications: ProductVerification[]) => {
        assignVerifications({
          verificationIds: verifications.map(
            (verification: ProductVerification) => verification.id
          )
        });
      }}
    />
  );
};

export default DesignOutputAssignVerificationDialog;
